import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ENV } from '../../../environments/environment';
import { roles } from '../../constant/constant';
import { platform } from '../../models/AppVersion';
import { TokenService } from '../../utilities/token.service';
import { AuthService } from '../auth.service';
import { ProviderStateService } from '../provider-state.service';


@Injectable({
    providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
    slug: string = "";
    constructor(
        private readonly auth: AuthService,
        private readonly router: Router,
        private readonly token: TokenService,
        private readonly providerstateService: ProviderStateService
    ) {
        this.slug = this.providerstateService.getProviderSlug();
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const token = sessionStorage.getItem('authtoken'); // you probably want to store it in localStorage or something
        const headers = req.headers
            .set('platform', platform.web)
            .set('app_version', ENV.app_version)
        const req_1 = req.clone({
            headers: headers,
            withCredentials: true
        });

        if (!token) {
            return next.handle(req_1);
        }

        const req1 = req.clone({
            headers: headers.set('Authorization', `Bearer ${token}`),
            withCredentials: true
        });

        return next.handle(req1).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 403)
                    return this.handle403Error(req1, next);
                else if (error instanceof HttpErrorResponse && error.status === 401)
                    return this.handle401Error(req1, next);
                else
                    return throwError(error);
            })
        );
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.router.navigate(['/' + this.slug + "/sessionexpired"]);
        return;
    }


    private handle403Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const role = this.token.findRole();
        if (role == roles.patient) {
            return this.auth.refresh().pipe(
                switchMap(result => {
                    sessionStorage.setItem('refresh_token', result.refreshToken);
                    sessionStorage.setItem('authtoken', result.accessToken);
                    return next.handle(this.addTokenHeader(request, result.accessToken));
                }),
                catchError((err) => {
                    return this.handle401Error(request, next);
                })
            )
        }
        else {
            return this.auth.refreshDoctor().pipe(
                switchMap(result => {
                    sessionStorage.setItem('refresh_token', result.refreshToken);
                    sessionStorage.setItem('authtoken', result.accessToken);
                    return next.handle(this.addTokenHeader(request, result.accessToken));
                }),
                catchError((err) => {
                    return this.handle401Error(request, next);
                })
            )
        }
    }

    private addTokenHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
    }

}
